import {priceFormat} from "@pg-mono/string-utils";

import {InquiryButtonTypeName} from "../../../../constants/inquiry_button_type";
import {OfferPriceType} from "../../../offer/types/OfferPriceType";

interface IGetLeadButtonTextParams {
    isPriceHidden: boolean;
    isProperty?: boolean;
    propertyPrice?: number | null;
    showPropertyExactPrice?: boolean;
    priceType?: OfferPriceType | null;
    currency?: string;
    preferShortFormat?: boolean;
    isPropertyList?: boolean;
}

export const getLeadButtonText = ({
    isPriceHidden = false,
    isProperty = false,
    propertyPrice,
    priceType,
    currency,
    showPropertyExactPrice = false,
    preferShortFormat = false,
    isPropertyList = false
}: IGetLeadButtonTextParams): InquiryButtonTypeName | string => {
    if (isProperty && propertyPrice && !isPriceHidden && showPropertyExactPrice) {
        const priceTypeString = priceType === OfferPriceType.NETTO ? " netto" : "";
        const currencyString = currency ? `${currency} ` : "";

        return priceFormat(propertyPrice, {unit: `${currencyString}${priceTypeString}`}) as string;
    }

    if (isProperty) {
        const detailsLabel = isPropertyList ? InquiryButtonTypeName.DETAILS : InquiryButtonTypeName.ASK_FOR_FULL_OFFER;
        return isPriceHidden ? InquiryButtonTypeName.PRICE : preferShortFormat ? InquiryButtonTypeName.ASK : detailsLabel;
    }

    return isPriceHidden ? InquiryButtonTypeName.PRICES : preferShortFormat ? InquiryButtonTypeName.ASK : InquiryButtonTypeName.OFFER;
};
import {priceFormat} from "@pg-mono/string-utils";

import {InquiryButtonTypeName} from "../../../../constants/inquiry_button_type";
import {OfferPriceType} from "../../../offer/types/OfferPriceType";

interface IGetLeadButtonTextParams {
    isPriceHidden: boolean;
    isProperty?: boolean;
    propertyPrice?: number | null;
    showPropertyExactPrice?: boolean;
    priceType?: OfferPriceType | null;
    currency?: string;
    preferShortFormat?: boolean;
    isPropertyList?: boolean;
}

export const getLeadButtonText = ({
    isPriceHidden = false,
    isProperty = false,
    propertyPrice,
    priceType,
    currency,
    showPropertyExactPrice = false,
    preferShortFormat = false,
    isPropertyList = false
}: IGetLeadButtonTextParams): InquiryButtonTypeName | string => {
    if (isProperty && propertyPrice && !isPriceHidden && showPropertyExactPrice) {
        const priceTypeString = priceType === OfferPriceType.NETTO ? " netto" : "";
        const currencyString = currency ? `${currency} ` : "";

        return priceFormat(propertyPrice, {unit: `${currencyString}${priceTypeString}`}) as string;
    }

    if (isProperty) {
        const detailsLabel = isPropertyList ? InquiryButtonTypeName.DETAILS : InquiryButtonTypeName.ASK_FOR_FULL_OFFER;
        return isPriceHidden ? InquiryButtonTypeName.PRICE : preferShortFormat ? InquiryButtonTypeName.ASK : detailsLabel;
    }

    return isPriceHidden ? InquiryButtonTypeName.PRICES : preferShortFormat ? InquiryButtonTypeName.ASK : InquiryButtonTypeName.OFFER;
};
